module.exports = __webpack_public_path__ + "static/media/top_logo_frame.985ee827.svg";